var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":_vm.buttonId}}),(_vm.loading)?_c('div',{staticClass:"paypal-btn-loading"},[_c('v-progress-circular',{attrs:{"size":"24","indeterminate":"","color":"black"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }